import { ControlModuleId } from '@models/control-module-id.enum';
import { PreferenceControlModule } from '@models/preference-control-modules.model';
import { PreferenceControlModuleService } from './preference-control-module.service';
import { map, Observable, ReplaySubject, take } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
	'providedIn': 'root'
})
export class PreferenceControlModuleManager {
	private preferenceControlModulesSource = new ReplaySubject<PreferenceControlModule[]>(1);
	constructor(
		private preferenceControlModuleService: PreferenceControlModuleService) {
		this.preferenceControlModuleService.getPreferenceControlModules().subscribe(data => {
			this.preferenceControlModulesSource.next(data);
		});
	}

	public getPreferenceControlModule$(id: ControlModuleId | string): Observable<PreferenceControlModule> {
		return this.preferenceControlModulesSource.pipe(
			map((preferenceControlModules) => {
				return preferenceControlModules.find((pcm: PreferenceControlModule) => pcm.moduleId === id);
			})
		);
	}

	public updateControlModuleState(targetControlModule: PreferenceControlModule): Observable<PreferenceControlModule> {
		this.preferenceControlModulesSource.pipe(
			take(1)
		).subscribe((preferenceControlModules) => {
			const preferenceControlModuleIndex = preferenceControlModules.findIndex((x) => x.moduleId === targetControlModule.moduleId);

			if (preferenceControlModuleIndex === -1) {
				preferenceControlModules.push(targetControlModule);
			} else {
				preferenceControlModules[preferenceControlModuleIndex] = targetControlModule;
			}
			this.preferenceControlModulesSource.next(preferenceControlModules);
		});

		return this.preferenceControlModuleService.updatePreferenceControlModule(targetControlModule);
	}
}
